<template>
    <authenticated-layout>
        <v-card class="pa-6 mx-auto" max-width="600">
            <form @submit.prevent="store">
                <div class="flex flex-col items-center">
                    <div
                        class="w-48 h-48 bg-white border-4 border-gray-300 overflow-hidden rounded-lg"
                    >
                        <img
                            :src="
                                user.profile_photo_url ??
                                '/images/profile-image-placeholder.png'
                            "
                            class="w-48 h-48 object-contain"
                        />
                    </div>

                    <div class="relative overflow-hidden">
                        <button
                            type="button"
                            class="bg-blue-500 hover:bg-blue-700 text-white font-bold mt-2 py-1.5 px-3 text-sm rounded"
                        >
                            {{ $t("profile.Upload a profile photo") }}
                        </button>

                        <input
                            :disabled="uploading"
                            type="file"
                            ref="profilePhoto"
                            class="absolute top-0 left-0 p-96 opacity-0 bg-transparent cursor-pointer"
                            accept="image/*"
                            @change="uploadProfilePhoto"
                        />
                    </div>
                </div>

                <div
                    v-if="user.profile_photo_url"
                    class="flex justify-between items-center mt-4 bg-gray-100 p-3 rounded-md"
                >
                    <p>
                        {{
                            $t(
                                "profile.Use your profile photo in the pdf offers"
                            )
                        }}
                    </p>

                    <div
                        class="w-14 h-7 flex flex-shrink-0 items-center bg-gray-300 rounded-full ml-2 px-1"
                        :class="{
                            'bg-green-500': form.use_profile_photo_in_offers,
                        }"
                        @click="
                            form.use_profile_photo_in_offers =
                                !form.use_profile_photo_in_offers
                        "
                    >
                        <div
                            class="bg-white w-5 h-5 rounded-full shadow-md transform translate-x-0"
                            :class="{
                                'translate-x-7':
                                    form.use_profile_photo_in_offers,
                            }"
                        />
                    </div>
                </div>

                <v-text-field
                    v-model="form.name"
                    :label="$t('profile.firstAndLastName')"
                    class="mt-6"
                    variant="outlined"
                    density="compact"
                    type="input"
                    :error-messages="form.errors.name"
                />

                <v-text-field
                    v-model="form.email"
                    :label="$t('profile.email')"
                    variant="outlined"
                    density="compact"
                    type="input"
                    :error-messages="form.errors.email"
                />

                <v-text-field
                    v-model="form.phone"
                    :label="$t('profile.phone')"
                    variant="outlined"
                    density="compact"
                    type="input"
                    :error-messages="form.errors.phone"
                />

                <v-text-field
                    v-model="form.extra_premium_pv"
                    :label="$t('profile.premiumPV')"
                    variant="outlined"
                    density="compact"
                    type="input"
                    :error-messages="form.errors.extra_premium_pv"
                />

                <v-text-field
                    v-model="form.extra_premium_hp"
                    :label="$t('profile.premiumPompy')"
                    variant="outlined"
                    density="compact"
                    type="input"
                    :error-messages="form.errors.extra_premium_hp"
                />

                <v-text-field
                    v-if="$page.props.auth.user.role !== 'sales'"
                    v-model="form.pd_id"
                    label="Pipedrive ID"
                    variant="outlined"
                    density="compact"
                    type="input"
                    :error-messages="form.errors.pd_id"
                />

                <v-btn
                    color="secondary"
                    variant="flat"
                    size="small"
                    type="submit"
                >
                    {{ $t("profile.save") }}
                </v-btn>
            </form>
        </v-card>
    </authenticated-layout>
</template>

<script>
import AuthenticatedLayout from "@/Layouts/Authenticated";

export default {
    props: {
        user: {
            type: Object,
            required: true,
        },
        errors: {
            type: [Array, Object, String],
        },
        message: {
            type: String,
        },
    },
    components: {
        AuthenticatedLayout,
    },
    computed: {},
    remember: "form",
    data() {
        return {
            form: this.$inertia.form({
                id: this.user.id,
                name: this.user.name,
                email: this.user.email,
                phone: this.user.phone,
                extra_premium_pv: this.user.extra_premium_pv,
                extra_premium_hp: this.user.extra_premium_hp,
                pd_id: this.user.pd_id,
                use_profile_photo_in_offers:
                    this.user.use_profile_photo_in_offers,
            }),
            uploading: false,
        };
    },
    mounted() {},
    methods: {
        uploadProfilePhoto() {
            this.uploading = true;

            const photo = this.$refs.profilePhoto.files[0] || null;

            this.$inertia.post(
                this.route("upload-profile-photo", this.user.id),
                { photo }
            );

            this.uploading = false;
        },
        store() {
            this.form.post(this.route("profile-update"));
        },
    },
};
</script>
